import "../../../../Assets/Styles/Containers/_commentLibraryModal.scss";
import { getTextColor } from "../../../Helpers/HelperFunctions";

const CommentTags = ({ tags }) => {
  return (
    <div className="comment_tags_container">
      {tags?.map((tag, index) => (
        <div
          key={index}
          className="comment_tag"
          style={{
            backgroundColor: tag?.tag?.color || tag?.color || "#000000",
            color: getTextColor("#000000"),
          }}
        >
          {tag?.tag?.name || tag?.name}
        </div>
      ))}
    </div>
  );
};

export default CommentTags;
